import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getTranslationProofsByOwnerOptions } from '@/module/Author/Translation/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface TranslationOwnerProofListProps {
  translationId: Id;
  userId: Id;
}

export function TranslationOwnerProofList({ translationId, userId }: TranslationOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getTranslationProofsByOwnerOptions(translationId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="translation"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
